import { MaterialReactTable } from "material-react-table";
import { eventColumnData } from "./constants/ListingCustomerFunctions";
import { MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import CommonButton from "../Utils/CommonButton";

export default function UsageEventsTable({ eventData, showJSON, setShowJSON }) {
  // const [showJSON, setShowJSON] = useState("false")
  const [JSONData, setJSONData] = useState(null);
  const eventColumn = eventColumnData();

  const copyJson = () => {
    navigator.clipboard.writeText(JSON.stringify(JSONData, null, 2));
  };

  return (
    <div className="border rounded-1 px-0 py-3 my-3 bg-white h-100">
      {showJSON && JSONData ? (
        <div className="mx-4 my-0 py-0">
          <div className="d-flex justify-content-between gap-2">
            <span className="fs-6 fw-medium align-self-center">
              JSON Structure
            </span>
            <CommonButton
              color={"secondary"}
              buttonText={"Copy"}
              buttonAction={copyJson}
              icon={
                <i className="ri-file-copy-2-line label-icon align-middle fs-16 me-1"></i>
              }
              className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1  w-md-auto text-nowrap"
              btnTxtClsName={"px-2 ps-3 ms-2 me-1"}
            />
          </div>
          <hr className="mt-3 pt-2 mb-2" />
          <pre className="mt-0 pt-0">{JSON.stringify(JSONData, null, 2)}</pre>
        </div>
      ) : eventData?.length > 0 ? (
        <MaterialReactTable
          columns={eventColumn}
          data={eventData}
          muiTablePaperProps={{
            elevation: 0,
          }}
          defaultColumn={{
            minSize: 10,
            maxSize: 9001,
            muiTableBodyCellProps: {
              sx: {
                fontFamily: "Inter,sans-serif",
              },
            },
            muiTableHeadCellProps: {
              sx: {
                fontFamily: "Inter,sans-serif",
              },
            },
          }}
          renderRowActionMenuItems={({ closeMenu, row }) => [
            <MenuItem
              key={`${row.index}.2`}
              onClick={() => {
                setShowJSON(true);
                setJSONData(row.original);
              }}
            >
              <i className="ri-eye-line me-2" /> View JSON{" "}
            </MenuItem>,
          ]}
          displayColumnDefOptions={{
            "mrt-row-actions": {
              header: "",
              enableHiding: false,
            },
          }}
          enableBottomToolbar={true}
          enableColumnActions={false}
          enableRowActions={true}
          enableDensityToggle={false}
          enablePagination={true}
          renderTopToolbar={false}
        />
      ) : (
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ minHeight: "200px" }}
        >
          No record to display
        </div>
      )}
    </div>
  );
}
